var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoffeeCup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 14H6.20725M6.20725 14H6.29275M6.20725 14C4.82228 13.9887 3.49788 13.4306 2.52254 12.4473C1.54721 11.4639 0.999954 10.135 1 8.75V5.69225C1 5.30975 1.30975 5 1.69225 5H10.8077C11.1902 5 11.5 5.30975 11.5 5.69225V5.75M6.29275 14H11.5M6.29275 14C7.67772 13.9887 9.00212 13.4306 9.97746 12.4473C10.9528 11.4639 11.5 10.135 11.5 8.75M11.5 5.75H12.625C13.1223 5.75 13.5992 5.94754 13.9508 6.29917C14.3025 6.65081 14.5 7.12772 14.5 7.625C14.5 8.12228 14.3025 8.59919 13.9508 8.95083C13.5992 9.30246 13.1223 9.5 12.625 9.5H11.5V8.75M11.5 5.75V8.75M9.25 1.25L8.5 2.75M7 1.25L6.25 2.75M4.75 1.25L4 2.75",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeCup);
export default __webpack_public_path__ + "static/media/coffee-cup.6fb731faa304dad88fafa4636b148d69.svg";
export { ForwardRef as ReactComponent };